import type { FC } from "react";

import { cn } from "@/lib/utils";

interface SortArrowProps {
  classes?: string;
}

const SortArrow: FC<SortArrowProps> = ({ classes }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      className={cn(classes)}
    >
      <path
        d="M4.37502 6.50002H13.375C13.4739 6.5 13.5705 6.47066 13.6527 6.41572C13.7349 6.36078 13.799 6.28269 13.8369 6.19134C13.8747 6.09999 13.8846 5.99948 13.8653 5.9025C13.846 5.80553 13.7984 5.71644 13.7285 5.64652L9.22852 1.14652C9.18211 1.10007 9.127 1.06322 9.06635 1.03808C9.00569 1.01294 8.94068 1 8.87502 1C8.80936 1 8.74434 1.01294 8.68369 1.03808C8.62303 1.06322 8.56792 1.10007 8.52152 1.14652L4.02152 5.64652C3.95161 5.71644 3.90401 5.80553 3.88472 5.9025C3.86544 5.99948 3.87534 6.09999 3.91318 6.19134C3.95101 6.28269 4.01508 6.36078 4.09729 6.41572C4.17949 6.47066 4.27614 6.5 4.37502 6.50002Z"
        fill="#AFAFAF"
      />
      <path
        d="M13.375 9.5H4.37502C4.27614 9.50002 4.17949 9.52936 4.09729 9.5843C4.01508 9.63924 3.95101 9.71732 3.91318 9.80867C3.87534 9.90002 3.86544 10.0005 3.88472 10.0975C3.90401 10.1945 3.95161 10.2836 4.02152 10.3535L8.52152 14.8535C8.56793 14.8999 8.62303 14.9368 8.68369 14.9619C8.74434 14.9871 8.80936 15 8.87502 15C8.94067 15 9.00569 14.9871 9.06634 14.9619C9.127 14.9368 9.18211 14.8999 9.22852 14.8535L13.7285 10.3535C13.7984 10.2836 13.846 10.1945 13.8653 10.0975C13.8846 10.0005 13.8747 9.90002 13.8369 9.80867C13.799 9.71732 13.7349 9.63924 13.6527 9.5843C13.5705 9.52936 13.4739 9.50002 13.375 9.5Z"
        fill="#AFAFAF"
      />
    </svg>
  );
};

export default SortArrow;
